module.exports = __webpack_public_path__ + "img/gate_cancelled.8b61561.svg";